import request from '@/utils/request'

/* 学生中心我的课程列表 */
export function centerCourseList(data) {
  return request({
    url: '/teaching/course/myCourse',
    method: 'post',
    data
  })
}

/* 课程分类 */
export function courseTypeList(data) {
  return request({
    url: '/teaching/courseType/list',
    method: 'get',
    data
  })
}

/* 首页热门课程 */
export function homeHotCourseList(data) {
  return request({
    url: '/teaching/course/hot',
    method: 'post',
    data
  })
}

/* 通过分类获取课程 */
export function homeCrouseByType(data) {
  return request({
    url: '/teaching/course/list',
    method: 'post',
    data
  })
}

/* 通过分类获取标签 */
export function tagByType(data) {
  return request({
    url: '/teaching/courseLabel/list',
    method: 'post',
    data
  })
}

/* 课程中心分页列表 */
export function teachingCenterCourseList(data) {
  return request({
    url: '/teaching/course/page',
    method: 'post',
    data
  })
}

/* 获取课程详情 */
export function courseDetails(data) {
  return request({
    url: '/teaching/course/detail',
    method: 'post',
    data
  })
}

/* 课程章节目录 */
export function courseChapterList(data) {
  return request({
    url: '/teaching/courseChapter/catalog',
    method: 'post',
    data
  })
}

/* 获取课程附加信息 */
export function courseOtherList(data) {
  return request({
    url: '/teaching/courseOther/list',
    method: 'post',
    data
  })
}


/* 制定课程标签 */
export function courseLabelList(data) {
  return request({
    url: '/teaching/courseLabel/labels',
    method: 'post',
    data
  })
}

/* 收藏课程 */
export function courseFavorite(data) {
  return request({
    url: '/teaching/favorite/course',
    method: 'post',
    data
  })
}

/* 取消收藏课程 */
export function courseRemoveFavorite(data) {
  return request({
    url: '/teaching/favorite/removeCourse',
    method: 'post',
    data
  })
}

/* 获取评价指标 */
export function courseTeacherEvaluate(data) {
  return request({
    url: '/teaching/evaluateIndex/list',
    method: 'post',
    data
  })
}

/* 评价 */
export function courseTeacherEvaluateAdd(data) {
  return request({
    url: '/teaching/courseEvaluate/add',
    method: 'post',
    data
  })
}

/* 查询课程平均分 */
export function courseTeacherEvaluateScore(data) {
  return request({
    url: '/teaching/courseEvaluate/score',
    method: 'post',
    data
  })
}

/* 查询课程是否评价 */
export function evaluateStatus(data) {
  return request({
    url: '/teaching/courseEvaluate/evaluateStatus',
    method: 'post',
    data
  })
}

/* 查询课程评价详情 */
export function courseEvaluateDetail(data) {
  return request({
    url: '/teaching/courseEvaluate/detail',
    method: 'post',
    data
  })
}

/* 在线问答 */
export function courseQuestionList(data) {
  return request({
    url: '/teaching/courseQuiz/page',
    method: 'post',
    data
  })
}

/* 新增提问 */
export function courseQuestionAdd(data) {
  return request({
    url: '/teaching/courseQuiz/add',
    method: 'post',
    data
  })
}

/* 查询单个问题回复列表 */
export function courseQuestionRecordList(data) {
  return request({
    url: '/teaching/courseQuizRecord/page',
    method: 'post',
    data
  })
}

/* 添加回复 */
export function courseQuestionRecordAdd(data) {
  return request({
    url: '/teaching/courseQuizRecord/add',
    method: 'post',
    data
  })
}

/* 讨论组列表 */
export function courseDiscussList(data) {
  return request({
    url: '/teaching/courseDiscuss/page',
    method: 'post',
    data
  })
}

/* 讨论组回复 */
export function courseDiscussAdd(data) {
  return request({
    url: '/teaching/courseDiscuss/add',
    method: 'post',
    data
  })
}

/* 加入学习 */
export function courseParticipantJoin(data) {
  return request({
    url: '/teaching/courseParticipant/join',
    method: 'post',
    data
  })
}

/* 获取课程章节资源 */
export function courseLessonResources(data) {
  return request({
    url: '/teaching/courseLesson/resources?lessonId=' + data,
    method: 'get'
  })
}

/* 记录学习 */
export function courseStudyCheckTime(data) {
  return request({
    url: '/teaching/lessonLearnRecord/study',
    method: 'post',
    data
  })
}

/* 预览练习 */
export function courseLessonPractice(data) {
  return request({
    url: '/teaching/lessonPracticeRecord/practice',
    method: 'post',
    data
  })
}

/* 课程练习保存答案 */
export function courseLessonPracticeSaveAnswer(data) {
  return request({
    url: '/teaching/lessonPracticeRecord/saveAnswer',
    method: 'post',
    data
  })
}

/* 获取授课老师 */
export function courseTeacher(data) {
  return request({
    url: '/teaching/courseTeacher/list',
    method: 'post',
    data
  })
}

/* 获取老师详情 */
export function teacherInfo(params) {
  return request({
    url: '/user/teacher/getSimpleInfo',
    method: 'get',
    params
  })
}

/* 推荐课程列表 */
export function coursereCommend(data) {
  return request({
    url: '/teaching/course/recommend',
    method: 'post',
    data
  })
}

/* 通过课程获取分类 */
export function coursereVote(data) {
  return request({
    url: '/teaching/courseVote/list',
    method: 'post',
    data
  })
}

/* 投票 */
export function coursereVoteSubmit(data) {
  return request({
    url: '/teaching/courseVote/vote',
    method: 'post',
    data
  })
}

/* 学生我的课程下拉框 */
export function myCourseSelectList() {
  return request({
    url: '/teaching/course/myCourse/list',
    method: 'get'
  })
}
